var trackFields = function trackFields(fields) {
  return fields.filter(function (field) {
    return field.gtmTrackingEnabled;
  }).map(function (_ref) {
    var name = _ref.name;
    return name;
  });
};

export default trackFields;
//# sourceMappingURL=form-track-fields.js.map